import {Link} from "react-router-dom";

const ServicesOptions = ({props}) => {
    const {text, url} = props;
  return(
      <div className="flex space-b mt-16">
          {url ?
              <Link className="services__link regular gray text-center flex space-b w-100" to={url} target="_blank">
                  <span>{text}</span>
                  <span className="services__link-btn white">&#9654;</span>
              </Link>
              : <p className="regular gray">{text}</p>
          }
      </div>
  )
}
export default ServicesOptions